import React, { Component, Fragment } from 'react';
import {
    LoadingComponent,
    PageListComponent,
    HeaderListComponent,
    FormActionComponent,
} from "../../../common/component/Index";
import i18n from "../../../../../constants/initLng";
import { PATHS } from "../../../../../constants/Define";
import { message } from 'antd';
import { isEqual, get, find } from 'lodash';
import * as Func from '../../../../../helpers/functions';
import CustomPrice from '../../../../../models/CustomPrice';
import Wrapper from './../../../common/component/Wrapper';
import Button from './../../../common/component/Button';
import Radio from './../../../common/component/Radio';
import PriceDetail from './PriceDetail';

import './CustomPriceDetail.less';

let permisionActions = [];
const defaultState = {
    action: "CREATE",
    isSubmit: false,
    isGetItem: false,
    validation: {},
};

export default class CustomPriceDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            price: this.props.customPriceState.detail.price,
        };
    }

    componentDidMount() {
        this.initDetail()
    }

    componentWillUnmount() {
        this.props.setCustomPriceDetail(new CustomPrice())
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.customPriceState.detail.price && !isEqual(nextProps.customPriceState.detail.price, this.props.customPriceState.detail.price)) {
            this.setState({ price: nextProps.customPriceState.detail.price, action: nextProps.customPriceState.detail.price.id ? 'UPDATE' : this.state.action });
        }
    }

    render() {
        const { t, customPriceState } = this.props;
        const { isFetching } = customPriceState;
        const { action, isSubmit, isGetItem, validation, price } = this.state;
        return (
            <LoadingComponent spinning={isFetching || isSubmit}>
                <PageListComponent className="hotel-detail-page">
                    <HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'prices'}
                        titleHeader={action === "CREATE"
                            ? Func.capitalizeFirstLetter((`${t('action.create')} ${t('item.price.title')}`).toLowerCase())
                            : Func.capitalizeFirstLetter((`${t('action.update')} ${t('item.price.title')}`.toLowerCase()))
                        }

                    />
                    <FormActionComponent
                        onSubmit={this.onSubmit}
                        isSubmit={isSubmit}
                        action={action}
                        isGetItem={isGetItem}
                        onClickBack={this.onClickBack}
                        activeComponent={'Switch'}
                        onChangeActive={e => this.onChangeDetail(e.name, e.value)}
                        titleActiveComponent={price.isActive ? t(`item.price.active`) : t(`item.price.deactive`)}
                        submitButtonRight={true}
                        statusActiveName={`isActive`}
                        statusActive={price.isActive}
                    >
                        <Wrapper className='col-md-12 p-0 m-0'>
                            <PriceDetail price={price} disabled={!price.isActive} validation={validation} onChange={this.onChangeDetail} onChangeValue={this.onChangeValue} />
                        </Wrapper>
                    </FormActionComponent>
                </PageListComponent>
            </LoadingComponent>
        );
    }

    initDetail() {
        const { match, customPriceState } = this.props;
        let price = this.state.price;
        if (Object.keys(match.params).length > 0 && match.params.hotel_id) {
            const hotelId = match.params.hotel_id;
            if (Object.keys(match.params).length > 0 && match.params.id) {
                const id = match.params.id;
                this.setState({ action: "UPDATE" });
                price = find(customPriceState.prices, item => item.id === id) || price;
                if (price) this.setState({ price });
                this.props.getCustomPriceDetail(id);
            }
            if (price.hotel) price.hotel.id = hotelId;
            this.setState({ price });
        }
        
    }

    onChangeDetail = (fieldName, value) => {
        const price = this.state.price;
        price[fieldName] = value;
        this.setState({ price });
    };

    onChangeValue = (fieldName, value) => {
        const newVal = value.replace(/,/g, "")
        const reg = /^-?[0-9]*(\.[0-9]*)?$/;
        if ((!isNaN(newVal) && reg.test(newVal)) || newVal === '' || newVal === '-') {
            this.onChangeDetail(fieldName, newVal);
        }
    }

    onSubmit = (e) => {
        e.preventDefault();
        if (this.validate()) {
            this.updateDetail()
        }
    };

    onClickBack = () => {
        const { match } = this.props;
        if (Object.keys(match.params).length > 0 && match.params.hotel_id) {
            const path = Func.getPathWithParams(PATHS.CUSTOM_PRICE.LIST.path, { hotel_id: match.params.hotel_id })
            this.props.history.push(path);
        }
    }

    validate() {
        const { t } = this.props;
        let validate = {
            required: {
                name: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.price.name`)),
                value: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.price.value`)),
                startDate: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.price.startDate`)),
            },
        };
        let valueValidate = {};
        const result = Func.multipleValidate(this.state.price, validate, valueValidate);
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }

    updateDetail() {
        const { price, action } = this.state;
        const actionFunction = action === 'CREATE' ? this.props.createCustomPrice : this.props.updateCustomPrice;
        actionFunction(price);
    }

}
